<template>
	<div class="card">
		<div class="card-header">
			Pengguna Presensi
			<el-tooltip placement="right" content="Kelola data pengguna">
				<el-button link type="primary" tag="router-link" to="pengguna">
					<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
				</el-button>
			</el-tooltip>
		</div>
		<div class="card-body row align-items-center" v-loading="loading">
			<span class="col-auto mx-auto" v-if="loading">Memuat...</span>
			<span class="col-auto mx-auto" v-else-if="!userPresensi.length">Data tidak ditemukan</span>
			<el-descriptions :column="1" border v-else>
				<el-descriptions-item v-for="up in userPresensi" :key="up.type" :label="userTypes[up.type] || 'lainnya'" label-align="right">
					<div class="hstack gap-1">
						<transition name="slide-up" mode="out-in">
							<span class="fs-5" :key="up.jumlah">{{ up.jumlah }}</span>
						</transition>
						<span>pengguna aktif</span>
					</div>
				</el-descriptions-item>
			</el-descriptions>
		</div>
	</div>
</template>

<script>
export default {
	name: "UserPresensi",
	data() {
		return {
			userPresensi: [],
			userTypes: {
				guru: "Guru",
				karyawan: "Tenaga Kependidikan",
				non_gtk: "Non-GTK",
				siswa: "Siswa",
			},
			loading: true,
		};
	},
	mounted() {
		this.$ws.main.on("user:inserted", this.insertedUser);
		this.$ws.main.on("user:deleted", this.deletedUser);
		this.getJumlahUserPresensi();
	},
	beforeUnmount() {
		this.$ws.main.off("user:inserted");
		this.$ws.main.off("user:deleted");
	},
	methods: {
		insertedUser(data) {
			const idx = this.userPresensi.findIndex((up) => up.type === data.type);

			if (idx !== -1) {
				this.userPresensi[idx].jumlah = this.userPresensi[idx].jumlah + 1;

				return;
			}

			this.userPresensi.push({
				type: data.type,
				jumlah: 1,
			});
		},
		deletedUser(data) {
			const idx = this.userPresensi.findIndex((up) => up.type === data.type);

			if (idx !== -1) {
				this.userPresensi[idx].jumlah = this.userPresensi[idx].jumlah - 1;
			}
		},
		async getJumlahUserPresensi() {
			try {
				const { data } = await this.$defaultApi.get("/user/count");

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.userPresensi = data.data.user_presensi_counts;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style scoped></style>
